module.exports = __webpack_public_path__ + "static/media/globe.93daa577.svg";